const DEFAULT_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8082';

/**
 * Calls the convert-lead-to-trial endpoint and enforces a strict success contract.
 * Throws when the backend fails (non-2xx) or when the payload is missing the expected flags.
 */
export async function convertLeadToTrial(payload, options = {}) {
  const apiBase = options.apiUrl || DEFAULT_API_URL;
  let response;
  try {
    response = await fetch(`${apiBase}/stripe/convert-lead-to-trial`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(options.authToken ? { Authorization: `Bearer ${options.authToken}` } : {}),
      },
      body: JSON.stringify(payload),
    });
  } catch (networkError) {
    const error = new Error('Unable to reach the payment server. Please check your connection and try again.');
    error.cause = networkError;
    throw error;
  }

  let data = null;
  try {
    data = await response.json();
  } catch {
    // Ignore JSON parse failures; we'll treat it as an invalid response below.
  }

  if (!response.ok || !data?.success || !data?.subscriptionId) {
    const message =
      data?.message ||
      data?.error ||
      'Failed to activate your trial. Please try again or contact support.';
    const error = new Error(message);
    error.response = data;
    error.status = response.status;
    throw error;
  }

  return data;
}

export default convertLeadToTrial;
